import React, { FC } from 'react'
import { Typography, Upload } from 'antd'
import { DraggerProps } from 'antd/lib/upload'
import Icon from '../Icon'
import LocalStorageService from '../../services/LocalStorageService'

const { Dragger } = Upload

const RDragger: FC<DraggerProps> = (props) => {
  return (
    <Dragger
      listType='picture'
      maxCount={1}
      headers={{ Authorization: LocalStorageService.getAuthToken() || '' }}
      {...props}
    >
      <Icon icon='file-arrow-up' color='primary' size='3x' />
      <Typography.Text className='d-block p-8' title='sdfgs' type='secondary'>
        Click or drag file to this area to upload
      </Typography.Text>
    </Dragger>
  )
}

export default RDragger
